import AddressHistory from "./AddressHistory";
import {IndividualContactSiteHistoriesUpdateApiDto, IndividualContactSiteHistoryApiDto} from "../../api/model/rest";
import JsonConverter from "../../api/helper/JsonConverter";

export default class IndividualContactAddressHistory {
	constructor(public readonly contactId: string, public readonly history: AddressHistory[]) {}

	toJson(): IndividualContactSiteHistoriesUpdateApiDto {
		const json: IndividualContactSiteHistoriesUpdateApiDto = {
			siteHistories: this.history.map(addressHistory => addressHistory.toJson())
		};
		return JsonConverter.removeEmptyFields(json);
	}

	//TODO this should be changed to json. API returns list without any wrapping json object.
	static fromJson(histories: IndividualContactSiteHistoryApiDto[], contactId: string) {
		return new IndividualContactAddressHistory(contactId, histories.map(AddressHistory.fromJson));
	}
}